import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice, faFileArchive } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';

const Activity = ({ activity: { processo, evento, data, processoid, operacao, importador, ident_cli_pro, exibeArquivo }, isLast }) => {
  let sigla = operacao === 'Agenciamento' ? 'A' :
    operacao === 'Exportação' ? 'E' : 'I';
  return (
    <Row
      className={classNames(
        'g-3 recent-activity-timeline recent-activity-timeline-primary',
        {
          'pb-x1': !isLast,
          'recent-activity-timeline-past': status === 'completed',
          'recent-activity-timeline-current': status === 'current'
        }
      )}
    >
      <Col xs="auto" className="ps-4 ms-2">
        <div className="ps-2">
          <div className="icon-item icon-item-sm rounded-circle bg-200 shadow-none">
            {/* <FontAwesomeIcon icon={icon} className="text-primary" /> */}
          </div>
        </div>
      </Col>
      <Col>
        <Row className={classNames('g-3', { 'border-bottom pb-x1': !isLast })}>
          <Col>
            {sigla === 'E' ?
              <>
                <h6 className="text-800 mb-1" style={{ fontSize: '0.625em' }}>{processo} | Ref: {ident_cli_pro} | Importador: {importador}</h6>
              </>
              :
              <>
                    <h6 className="text-800 mb-1" style={{ fontSize: '0.625em' }}>{processo} | Ref: {ident_cli_pro} | Exportador: {importador}</h6>
              </>}

            <p className="text-600 mb-0" style={{ fontSize: '0.625em' }}>{evento}</p>
          </Col>
          <Col xs="auto">
            <p className="fs--2 text-500 mb-0" style={{ fontSize: '0.625em' }}>{data}</p>
          </Col>
          <Col xs="auto">
            <Link
              to={{
                // pathname: '/app/process/process-details/' + sigla + '&' + id
                pathname: '/app/process/process-details/' + sigla + '&' + processoid
              }}
            >
              {/* <strong>{processoid}</strong> */}
              <strong>
                {/* {processo} */}
                <FontAwesomeIcon icon={faFileInvoice} title='Detalhes' style={{ cursor: 'pointer' }} size="lg" />
              </strong>{' '}
            </Link>{' '}
            {exibeArquivo === "1" ?
              <>
                <Link
                  to={{
                    // pathname: '/app/process/process-details/' + sigla + '&' + id
                    pathname: '/app/process/process-details/' + sigla + '&' + processoid
                  }}
                >
                  {/* <strong>{processoid}</strong> */}
                  <strong>
                    {/* {processo} */}
                    <FontAwesomeIcon icon={faFileArchive} title='Arquivos' style={{ cursor: 'pointer' }} size="lg" />
                  </strong>{' '}


                </Link>{' '}
              </> : <></>}

          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const AtividadesRecentes = ({ title, data, operacao, exibeArquivo }) => {  
  return (

    <Card className="h-auto recent-activity-card">
      <FalconCardHeader title={title} titleTag="h6" />
      <SimpleBarReact style={{ height: '48rem', overflow: 'auto'  }}>
        <Card.Body className="ps-2 recent-activity-body-height">
          {data.map((activity, index) => (
            <Activity
              key={activity.processo}
              activity={activity}
              title={title}
              isLast={index === data.length - 1}
              id={activity.processoid}
              exibeArquivo={"1"}
            />
          ))}
        </Card.Body>
      </SimpleBarReact>
    </Card>
  );
};

Activity.propTypes = {
  activity: PropTypes.shape({
    id: PropTypes.number,
    // title: PropTypes.string.isRequired,
    processo: PropTypes.string.isRequired,
    evento: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    processoid: PropTypes.number,
    operacao: PropTypes.string.isRequired,
    exibeArquivo: PropTypes.number,
  }),
  isLast: PropTypes.bool
};

AtividadesRecentes.propTypes = {
  data: PropTypes.arrayOf(Activity.propTypes.activity),
  exibeArquivo: PropTypes.number,
  operacao: PropTypes.string.isRequired,
};

export default AtividadesRecentes;
